/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChartDataRange } from './ChartDataRange';
import {
    ChartDataRangeFromJSON,
    ChartDataRangeFromJSONTyped,
    ChartDataRangeToJSON,
    ChartDataRangeToJSONTyped,
} from './ChartDataRange';

/**
 * 
 * @export
 * @interface ChartDataRepresentation
 */
export interface ChartDataRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ChartDataRepresentation
     */
    metricKey: string;
    /**
     * x value of the request resource, corresponding x and y points are matched via index
     * @type {Array<number>}
     * @memberof ChartDataRepresentation
     */
    x: Array<number>;
    /**
     * y value of the request resource, corresponding x and y points are matched via index
     * @type {Array<number>}
     * @memberof ChartDataRepresentation
     */
    y: Array<number>;
    /**
     * optional, currently only used for turbit power deviations
     * @type {Array<ChartDataRange>}
     * @memberof ChartDataRepresentation
     */
    ranges?: Array<ChartDataRange>;
}

/**
 * Check if a given object implements the ChartDataRepresentation interface.
 */
export function instanceOfChartDataRepresentation(value: object): value is ChartDataRepresentation {
    if (!('metricKey' in value) || value['metricKey'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    return true;
}

export function ChartDataRepresentationFromJSON(json: any): ChartDataRepresentation {
    return ChartDataRepresentationFromJSONTyped(json, false);
}

export function ChartDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'metricKey': json['metricKey'],
        'x': json['x'],
        'y': json['y'],
        'ranges': json['ranges'] == null ? undefined : ((json['ranges'] as Array<any>).map(ChartDataRangeFromJSON)),
    };
}

export function ChartDataRepresentationToJSON(json: any): ChartDataRepresentation {
    return ChartDataRepresentationToJSONTyped(json, false);
}

export function ChartDataRepresentationToJSONTyped(value?: ChartDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metricKey': value['metricKey'],
        'x': value['x'],
        'y': value['y'],
        'ranges': value['ranges'] == null ? undefined : ((value['ranges'] as Array<any>).map(ChartDataRangeToJSON)),
    };
}

